import React from 'react';

import { LibraryContentCard, LibraryContentCardInterfaceProps } from 'src/common/components/library/content-card';
import { Node } from 'src/common/interfaces/node.interface';
import { Step } from 'src/common/interfaces/step.interface';
import AddStepToSectionButton from '../components/buttons/add-step-to-section.button';

interface EditorSectionStepCardProps extends Pick<LibraryContentCardInterfaceProps, 'type'> {
  node: Node;
  isDragging: boolean;
  draggable?: boolean;
  isActive?: boolean;
  enableMenu?: boolean;
  onClick: () => void;
  step?: Step;
}

export const EditorSectionStepCard = ({
  draggable = true,
  isActive,
  node,
  step,
  ...rest
}: EditorSectionStepCardProps) => {
  return (
    <LibraryContentCard
      node={node}
      step={step}
      isActive={isActive}
      draggable={draggable}
      name={node.name?.trim() || 'Name your step'}
      {...rest}
      renderAdditional={() => (
        <div className='absolute -bottom-[12px] left-0 flex justify-end z-30 !ml-[20px] w-[316px]'>
          <AddStepToSectionButton step={step} node={node} />
        </div>
      )}
    />
  );
};
